//layout change
// const layOutButton = document.querySelector('.button-block .view-switch'); 
// if(layOutButton){
//   const collectionGrid = document.querySelector('.product-grid-container');
//    layOutButton.addEventListener('click', function() {
//       collectionGrid.classList.toggle('layout-change');
//   });
// }

// document.addEventListener('DOMContentLoaded', function () {
//   const layOutButton = document.querySelector('.button-block .view-switch');
//   const collectionGrid = document.querySelector('.product-grid-container');
//   const currentPath = window.location.pathname;

//   // ✅ Step 1: Check if we are on the same page and restore view
//   const savedView = sessionStorage.getItem('photoView');
//   const savedPath = sessionStorage.getItem('photoViewPath');

//   // ✅ Only apply photo view if path matches
//   if (savedView === 'photo' && savedPath === currentPath) {
//     collectionGrid.classList.add('layout-change');
//   } else {
//     sessionStorage.removeItem('photoView');
//     sessionStorage.removeItem('photoViewPath');
//     collectionGrid.classList.remove('layout-change');
//   }

//   // ✅ Step 2: Toggle button click
//   if (layOutButton && collectionGrid) {
//     layOutButton.addEventListener('click', function () {
//       const isPhotoView = collectionGrid.classList.toggle('layout-change');

//       if (isPhotoView) {
//         sessionStorage.setItem('photoView', 'photo');
//         sessionStorage.setItem('photoViewPath', currentPath);
//       } else {
//         sessionStorage.removeItem('photoView');
//         sessionStorage.removeItem('photoViewPath');
//       }
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  const layOutButton = document.querySelector('.button-block .view-switch');
  const collectionGrid = document.querySelector('.product-grid-container');
  const currentPath = window.location.pathname;

  // ✅ Only apply logic on collection page
  if (!collectionGrid) return;

  const savedView = sessionStorage.getItem('photoView');
  const savedPath = sessionStorage.getItem('photoViewPath');
  const savedTime = sessionStorage.getItem('photoViewTimestamp');
  const now = new Date().getTime();
  const maxAllowedTime = 2 * 60 * 1000; // 2 minutes

  const isStillValid = savedView && savedPath === currentPath && savedTime && (now - parseInt(savedTime, 10) < maxAllowedTime);

  // ✅ Apply view if still within 2 minutes
  if (isStillValid) {
    if (savedView === 'photo') {
      collectionGrid.classList.add('layout-change');
    } else {
      collectionGrid.classList.remove('layout-change');
    }
  } else {
    // ❌ Expired or not same path — reset view
    sessionStorage.removeItem('photoView');
    sessionStorage.removeItem('photoViewPath');
    sessionStorage.removeItem('photoViewTimestamp');
    collectionGrid.classList.remove('layout-change'); // Default layout view
  }

  // ✅ On toggle click
  if (layOutButton) {
    layOutButton.addEventListener('click', function () {
      const isPhotoView = collectionGrid.classList.toggle('layout-change');

      sessionStorage.setItem('photoView', isPhotoView ? 'photo' : 'layout');
      sessionStorage.setItem('photoViewPath', currentPath);
      sessionStorage.setItem('photoViewTimestamp', new Date().getTime().toString());
    });
  }
});










//filter toggle
const fitlerToggleButton = document.querySelector('.filter-toggle .btn-search-trigger');
if(fitlerToggleButton){
  const collectionFilter = document.querySelector('.custom-collection-filter');
  fitlerToggleButton.addEventListener('click', function(){
    collectionFilter.classList.add('active');
    body.classList.add('filter-open');
  });
  const filterCloseButton = document.querySelector('.custom-collection-filter .close-icon .svg-wrapper');
  const body =document.querySelector('body');
     filterCloseButton.addEventListener('click', function(){
      collectionFilter.classList.remove('active');
       body.classList.remove('filter-open');
  });
   // Close popup when clicking on overlay
   body.addEventListener('click', function(e) {
    if (e.target === body && body.classList.contains('filter-open')) {
       collectionFilter.classList.remove('active');
       body.classList.remove('filter-open');
    }
  });
}

// ✅ Sort Product Grid By Square Footage
function sortProductGrid() {
  const productGrid = document.getElementById('product-grid');
  if (!productGrid) return;

  const urlParams = new URLSearchParams(window.location.search);
  const sqftMin = parseInt(urlParams.get('filter.p.sqft_min') || '0');
  const sqftMax = parseInt(urlParams.get('filter.p.sqft_max') || '99999');

  const productItems = Array.from(productGrid.querySelectorAll('.grid__item'));

  // Filter products based on sqft range
  const filteredItems = productItems.filter(item => {
    const sqft = parseInt(item.getAttribute('data-square-footage')) || 0;
    return sqft >= sqftMin && sqft <= sqftMax;
  });

  // Sort ascending
  filteredItems.sort((a, b) => {
    const sqFtA = parseInt(a.getAttribute('data-square-footage')) || 0;
    const sqFtB = parseInt(b.getAttribute('data-square-footage')) || 0;
    return sqFtA - sqFtB;
  });

  // Re-render sorted products
  productGrid.innerHTML = '';
  filteredItems.forEach((item, index) => {
    item.style.setProperty('--animation-order', index + 1);
    productGrid.appendChild(item);
  });
}

// ✅ On Sort Change
const selectElement = document.querySelector('.custom-select-block .facet-filters__sort');
if (selectElement) {
  selectElement.addEventListener('change', function () {
    const selectedValue = this.value;
    const currentUrl = new URL(window.location.href);

    const sqftMin = currentUrl.searchParams.get('filter.p.sqft_min');
    const sqftMax = currentUrl.searchParams.get('filter.p.sqft_max');

    // Remove old sort_by (in case it's changing)
    currentUrl.searchParams.delete('sort_by');

    if (selectedValue === 'filter.p.sqft_min=0&filter.p.sqft_max=9999') {
      // ✅ If sqft filters NOT already set, add default range
      if (!sqftMin || !sqftMax) {
        currentUrl.searchParams.set('filter.p.sqft_min', '0');
        currentUrl.searchParams.set('filter.p.sqft_max', '9999');
      }
      // ✅ Don't add sort_by param – handled visually
    } else {
      // ✅ Set sort_by value for other options
      currentUrl.searchParams.set('sort_by', selectedValue);
    }

    window.location.href = currentUrl.toString();
  });
}


// ✅ On Page Load: Set Sort Option and Trigger Visual Sort
document.addEventListener('DOMContentLoaded', function () {
  const selectElement = document.querySelector('.custom-select-block .facet-filters__sort');
  if (!selectElement) return;

  const urlParams = new URLSearchParams(window.location.search);
  const sortBy = urlParams.get('sort_by');
  const sqftMin = urlParams.get('filter.p.sqft_min');
  const sqftMax = urlParams.get('filter.p.sqft_max');

  let valueToSelect = 'created-descending'; // Default

  if (sortBy) {
    valueToSelect = sortBy;
  } else if ((sqftMin === '0' && sqftMax === '9999') || (!sortBy && sqftMin && sqftMax)) {
    valueToSelect = 'filter.p.sqft_min=0&filter.p.sqft_max=9999';
  }

  Array.from(selectElement.options).forEach(option => {
    option.selected = option.value === valueToSelect;
  });

  if (valueToSelect === 'filter.p.sqft_min=0&filter.p.sqft_max=9999' || (!sortBy && sqftMin && sqftMax)) {
    sortProductGrid();
  }
});


// ✅ When more products load (pagination / load-more)
document.addEventListener('collection:updated', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const sortParam = urlParams.get('sort_by');
  const sqftMin = urlParams.get('filter.p.sqft_min');
  const sqftMax = urlParams.get('filter.p.sqft_max');

  if (
    sortParam === 'filter.p.sqft_min=0&filter.p.sqft_max=9999' ||
    (!sortParam && sqftMin && sqftMax)
  ) {
    sortProductGrid();
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const emptyCollection = document.querySelector('.collection.collection--empty');
  const productGrid = document.getElementById('product-grid');

  const emptyHTML = `
    <div class="loading-overlay gradient"></div>
    <div class="title-wrapper center">
      <h2 class="title title--primary">
        Sorry, we haven’t designed this one yet, please broaden your search and try again
      </h2>
    </div>
  `;

   const gridemptyHTML = `
      <div class="collection collection--empty page-width" id="product-grid">
            <div class="loading-overlay gradient"></div>
            <div class="title-wrapper center">
              <h2 class="title title--primary">
               Sorry, we haven’t designed this one yet, please broaden your search and try again
              </h2>
            </div>
          </div>
  `;

  // 🔁 OBSERVER FOR EMPTY COLLECTION (already present)
  if (emptyCollection) {
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && emptyCollection.children.length === 0) {
          emptyCollection.innerHTML = emptyHTML;
        }
      }
    });
    observer.observe(emptyCollection, { childList: true });

    if (emptyCollection.children.length === 0) {
      emptyCollection.innerHTML = emptyHTML;
    }
  }

  // 🧠 NEW LOGIC: If #product-grid has no <li>, show message inside it
  if (productGrid) {
    const gridObserver = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          checkAndInjectEmptyGrid();
        }
      }
    });

    function checkAndInjectEmptyGrid() {
      const items = productGrid.querySelectorAll('li');
      if (items.length === 0 && !productGrid.classList.contains('empty-message-injected')) {
        productGrid.innerHTML = gridemptyHTML;
        productGrid.classList.add('empty-message-injected');
      }
    }

    // Observe <ul> changes
    gridObserver.observe(productGrid, { childList: true });
    checkAndInjectEmptyGrid(); // Initial check
  }
});



